import { Component, OnInit } from '@angular/core';
import { Router ,NavigationStart, NavigationEnd, } from "@angular/router";
import { environment } from "../../environments/environment";

@Component({
  selector: 'app-wrong-url',
  templateUrl: './wrong-url.component.html',
  styleUrls: ['./wrong-url.component.scss']
})
export class WrongUrlComponent implements OnInit {
    value_url: any;
  constructor(private router:Router) {
      this.router.events.subscribe( event =>{
          if(event instanceof NavigationEnd && event.urlAfterRedirects == "/wrong-url"){
              setTimeout(function(){
                $(".nav-top.header").hide();
                $(".banner-top").hide();
              },0);
          }
          if(event instanceof NavigationStart && event.url != "/wrong-url"){
                setTimeout(function(){
                    $(".nav-top.header").show();
                    $(".banner-top").show();
                },0);
          }
      })
   }

  ngOnInit() {
      // console.log(environment.linkCheckUrl);    
      this.value_url = environment.linkCheckUrl
  }

}
